export default __webpack_public_path__ + "static/098-54a6922d0692e5100c051ac7012dcc2d.jpg";